import React from "react";
import '../ChecklistDiario.scss'
import { Button } from "primereact/button";

const Indicadores = ({ setFiltroIndicadores, totalCount, conProblemasCount }) => {
    return (
        <div className="indicadores">
            <div className="totalContainer">
                <Button onClick={()=>{setFiltroIndicadores('total')}} label={`Total ${totalCount}`} style={{ fontSize: 'small' }}></Button>
                <Button onClick={()=>{setFiltroIndicadores('conProblemas')}} style={{ backgroundColor: 'var(--highlight-bg)', color: 'var(--highlight-text-color)', fontSize: 'small' }} label={`Con problemas ${conProblemasCount}`}></Button>
            </div>
        </div>
    )
}
export default Indicadores